import React, { useContext, useEffect, useState } from "react";
import styled from "@emotion/styled";
import FilterIcon from "./filter-icon.svg";
import client from "../../graphql";
import { gql } from "@apollo/client";
import { FilterContext } from "../../Context/FilterContext";
import { MovieContext } from "../../Context/MovieContext";
import { getMovies } from "../../MovieQueries";
import CloseIcon from "../Navbar/cancel-icon-grey.svg";

export default function FilterBar({ ShowFilterBar, setShowFilterBar }) {
  const [FilterOptions, setFilterOptions] = useState({
    languages: [{ language: "All", id: "All" }],
    genres: [{ type: "All", id: "All" }],
    years: [{ year: "All", id: "All" }],
  });
  const { Filters, setFilters } = useContext(FilterContext);
  const [SelectedFilters, setSelectedFilters] = useState(Filters);
  const { moviesList, setmoviesList } = useContext(MovieContext);
  useEffect(() => {
    client
      .query({
        query: gql`
          query {
            movieLanguages {
              id
              language
            }
            movieYears {
              id
              year
            }
            movieGenres {
              id
              type
            }
          }
        `,
      })
      .then((result) => {
        let filters = {};
        filters.languages = [
          { language: "All", id: "All" },
          ...result.data.movieLanguages,
        ];
        filters.genres = [
          { type: "All", id: "All" },
          ...result.data.movieGenres,
        ];
        filters.years = [{ year: "All", id: "All" }, ...result.data.movieYears];
        setFilterOptions({ ...filters });
      })
      .catch((err) => console.error("Unable to fetch filter options"));
    return () => {};
  }, []);

  useEffect(() => {
    getMovies(10, Filters, moviesList, setmoviesList);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Filters]);
  return (
    <Container style={{ left: ShowFilterBar ? "0%" : "-100%" }}>
      <CloseButton
        src={CloseIcon}
        onClick={() => setShowFilterBar(!ShowFilterBar)}
      />
      <div className="toggle-btn">
        <img src={FilterIcon} alt="" /> Filter
      </div>
      <Filter>
        <label htmlFor="Genre">Genre </label>
        <select
          name="Genre"
          onChange={(e) =>
            setSelectedFilters({
              ...SelectedFilters,
              [e.target.name.toLocaleLowerCase()]: e.target.value,
            })
          }
        >
          {FilterOptions.genres.map((genre) => (
            <option
              value={genre.id}
              selected={Filters && Filters.genre === genre.id}
              key={genre.id}
            >
              {genre.type}
            </option>
          ))}
        </select>
      </Filter>
      <Filter>
        <label htmlFor="Language">Language </label>
        <select
          name="Language"
          onChange={(e) =>
            setSelectedFilters({
              ...SelectedFilters,
              [e.target.name.toLocaleLowerCase()]: e.target.value,
            })
          }
        >
          {FilterOptions.languages.map((language) => (
            <option
              value={language.id}
              selected={Filters && Filters.language === language.id}
              key={language.id}
            >
              {language.language}
            </option>
          ))}
        </select>
      </Filter>
      <Filter>
        <label htmlFor="Year">Year </label>
        <select
          name="Year"
          onChange={(e) =>
            setSelectedFilters({
              ...SelectedFilters,
              [e.target.name.toLocaleLowerCase()]: e.target.value,
            })
          }
        >
          {FilterOptions.years.map((year) => (
            <option
              value={year.id}
              selected={Filters && Filters.year === year.id}
              key={year.id}
            >
              {year.year}
            </option>
          ))}
        </select>
      </Filter>
      <button
        onClick={() => {
          setFilters({ ...SelectedFilters, movies: [] });
        }}
      >
        Apply
      </button>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  transition: left 0.6s;
  @media (max-width: 768px) {
    position: absolute;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
    backdrop-filter: blur(17px);
    -webkit-backdrop-filter: blur(17px);
    border-radius: 10px;
    z-index: 10;
    top: 0;
    left: 0%;
    height: 100vh;
    width: fit-content;
    display: block;
    padding: 20px 40px 0px 40px;
  }
  .toggle-btn,
  button {
    display: flex;
    & > img {
      display: inline;
      height: 16px;
      margin-right: 5px;
    }
    margin-right: 10px;
    background: #fcfcfc;
    padding: 13px;
  }

  button {
    border: 1px solid rgba(0, 0, 0, 0.5);
    padding: 12px;
    cursor: pointer;
  }
`;
const Filter = styled.div`
  margin-right: 10px;
  background: #fcfcfc;
  @media (max-width: 768px) {
    background: transparent;
  }
  padding: 5px 10px;
  & > label {
    margin-right: 10px;
    @media (max-width: 768px) {
      display: block;
      font-size: 103%;
      margin-bottom: 5px;
    }
  }
  & > select {
    border: 1px solid grey;
    background: white;
    border: 1px solid rgba(0, 0, 0, 0.15);
    padding: 5px;
    @media (max-width: 768px) {
      padding: 2%;
    }
  }
  @media (max-width: 768px) {
    padding: 10px 0;
  }
`;

const CloseButton = styled.img`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 30px;
  height: 30px;
  @media (min-width: 768px) {
    display: none;
  }
`;
